import { Stack, Typography } from "@mui/material";
import * as React from "react";

// components
import Link from "../utils/link";

interface AddressProps {
  language?: "it" | "en" | "es";
}

// markup
const Address = ({ language }: AddressProps) => {
  const content = {
    it: {
      name: "Mettifogo S.r.l",
      address: "Via Torre Orti, 2 - 37030 Vago di Lavagno (VR)",
      hours:
        "dal lunedì al giovedì: 8.00 - 12.00 / 14.00 - 18.00\nvenerdì: 8.00 - 12.30 / 13.30 - 17.00",
      phone: "Telefono",
      email: "Email",
      legal:
        "P.IVA: 00250380235 - REA VR 115247\nCapitale Sociale i.v. € 40.000,00",
    },
    en: {
      name: "Mettifogo S.r.l",
      address: "Via Torre Orti, 2 - 37030 Vago di Lavagno (VR) - Italy",
      hours:
        "from Monday to Thursday: 8.00 - 12.00 / 14.00 - 18.00\nFriday: 8.00 - 12.30 / 13.30 - 17.00",
      phone: "Phone",
      email: "Email",
      legal:
        "P.IVA: 00250380235 - REA VR 115247\nSocial Capital i.v. € 40.000,00",
    },
    es: {
      name: "Mettifogo S.r.l",
      address: "Via Torre Orti, 2 - 37030 Vago di Lavagno (VR) - Italia",
      hours:
        "de lunes a jueves: 8.00 - 12.00 / 14.00 - 18.00\nviernes: 8.00 - 12.30 / 13.30 - 17.00",
      phone: "Teléfono",
      email: "Correo electrónico",
      legal:
        "P.IVA: 00250380235 - REA VR 115247\nCapital Social i.v. € 40.000,00",
    },
  };

  const selectedContent = content[language || "it"];

  return (
    <Stack spacing={2}>
      <Typography variant="h4" component="p">
        <strong>{selectedContent.name}</strong>
      </Typography>

      <Typography>{selectedContent.address}</Typography>

      <Typography>
        {selectedContent.hours.split("\n").map((line, index) => (
          <React.Fragment key={index}>
            {line}
            <br />
          </React.Fragment>
        ))}
      </Typography>

      <Link type="external" href="tel:+390458980097" title="Call">
        {selectedContent.phone}: 045 8980097
      </Link>

      <Link type="external" href="mailto:info@mettifogo.eu" title="Send email">
        {selectedContent.email}: info@mettifogo.eu
      </Link>

      <Typography variant="caption">
        {selectedContent.legal.split("\n").map((line, index) => (
          <React.Fragment key={index}>
            {line}
            <br />
          </React.Fragment>
        ))}
      </Typography>
    </Stack>
  );
};

export default Address;
